<template>
  <div style="background:rgba(107, 17, 20);">
    <div style="display:flex;flex-direction: row;align-items: center;padding:20px;background-color:#990005;">
        <div style="font-size:22px;font-style: italic;color:#fff;margin-right:8px;">德宏</div>
        <div>
            <div style="font-style: italic;color:#fff;font-size:16px;">全国房地产行业交流会</div>
            <div style="font-style: italic;color:#fff;font-size:12px;">PROJECT MARKETING SEMINAR</div>
        </div>
    </div>
    <div style="position:relative;">
        <img src="../assets/images/top22.png" alt="" style="width:100%;">
    </div>
    <!-- //臻荟选房 -->
    <div style="padding:0px 10px;">
        <VideoPlay
              style="width:100%!important;margin-top:10px;"
              videoUrl="https://www.ynydc.com/video/showVideoById?id=68741"
              videoCover="https://www.ynydc.com/resources/webapp/realEestateFair/img/video-cover.png"
              :autoplay="false"
              :controls="true"
              :loop="false"
              :muted="false"
              preload="auto"
              :showPlay="true"
              zoom="cotain"
            />
    </div>
    <!-- //领导贺词 -->
    <div style="marginTop:20px;padding:10px;">
        <div class="titbox" style="margin-bottom:10px;">
            <div class="engtit">SPEECH</div>
            <div class="tit">美丽德宏</div>
        </div>
        <div style="marginBottom:30px;">
            <p style="color: #fff;font-size: 15px;padding: 0px 10px;text-indent: 2em;line-height: 28px;font-family: monospace;">德宏是孔雀之乡，坐落于祖国的边陲，东和东北与保山市的龙陵、腾冲相邻，南、西和西北三面与缅甸联邦接壤，全州除梁河县外其它县市都有国境线，国境线长达503.8公里，辖区面积11526平方千米，属南亚热带气候，州内有傣族、景颇族、阿昌族、傈僳族、德昂族5个世居少数民族为主的40多种少数民族，少数民族人口60.64万人，占总人口的45.90%。</p>
        </div>
    </div>
    <!-- 会议议程 -->
    <div style="marginTop:20px;padding:10px;">
        <div class="titbox" style="margin-bottom:10px;">
            <div class="engtit">AGENDA</div>
            <div class="tit">会议议程</div>
        </div>
        <div style="marginBottom:30px;display: flex;justify-content: center;align-items: center;">
           <img src="../assets/images/05.png" style="width: 90%;;"/>
        </div>
    </div>
    
    <div style="marginTop:20px;padding:10px;">
        <div class="titbox" style="margin-bottom:10px;">
            <div class="engtit">MEETING</div>
            <div class="tit">峰会亮点</div>
        </div>
        <div style="marginBottom:30px;display: flex;justify-content:space-between;align-items: center;flex-wrap: wrap;">
           <div style="width:49%;margin-bottom:6px;position: relative;">
                <div style="position:absolute;right:5%;top:20%">
                    <div style="font-size: 16px;color: #fff;text-align: right;">柴强</div>
                    <div style="font-size: 12px;color: #fff;margin-top: 4px;">房地产发展新模式</div>
                </div>
                <img src="../assets/images/01.png" width="100%" />
           </div>
           <div style="width:49%;margin-bottom:6px;position: relative;">
                <div style="position:absolute;left:5%;top:20%">
                    <div style="font-size: 16px;color: #fff;text-align: left;">王 韶</div>
                    <div style="font-size: 12px;color: #fff;margin-top: 4px;">全国房地产形势分析</div>
                </div>
                <img src="../assets/images/02.png" width="100%" />
           </div>
           <div style="width:49%;margin-bottom:6px;position: relative;">
                <div style="position:absolute;right:5%;top:20%">
                    <div style="font-size: 16px;color: #fff;text-align: right;">周大研</div>
                    <div style="font-size: 12px;color: #fff;margin-top: 4px;">云南省房地产现状及未来趋势分析</div>
                </div>
                <img src="../assets/images/04.png" width="100%" />
           </div>
           <div style="width:49%;margin-bottom:6px;position: relative;">
                <div style="position:absolute;left:5%;top:20%">
                    <div style="font-size: 16px;color: #fff;text-align:left;">曾 婷</div>
                    <div style="font-size: 12px;color: #fff;margin-top: 4px;">德宏州旅居地产创新发展的思考</div>
                </div>
                <img src="../assets/images/03.png" width="100%" />
           </div>
        </div>
    </div>
    <!-- //好房子 -->
    <div style="padding:10px;" v-if="houseList.length!=0">
        <div class="titbox">
            <div class="engtit">HOUSE</div>
            <div class="tit">房源展示</div>
        </div>
        <div style="width:100%;display:flex;flex-direction:row;align-items:center;justify-content:space-between;flex-wrap:wrap;marginTop:10px;">
            <div style="width:48%;marginBottom:10px;backgroundColor:#fff;overflow:hidden;border-radius:6px;" v-for="(item,index) in houseList" :key="index" @click="goHouseDetail(item)">
                <img :src="`${imgsrc}/picture/BUILD_FILE_COVER_IMAGE/${item.id}/getPicTypeIdAndFileType`" alt="" style="width:100%;height:120px;object-fit:cover;">
                <div style="fontSize:16px;margin:6px;text-overflow: ellipsis;white-space: nowrap;overflow:hidden;font-weight:bold;">{{item.preName}}</div>
                <div style="margin:6px;"><span style="padding:3px;color:#8B98A8;background-color:#F1F5F8;fontSize:13px;margin-right:4px;" v-for="(it,ic) in item.features.feature.slice(0,3)" :key="ic+'tag'">{{it}}</span></div>
                <div style="margin:6px;text-overflow: ellipsis;white-space: nowrap;overflow:hidden;"><span style="color:#9F9F9F;fontSize:14px;">{{item.fCountyX}}</span><el-divider direction="vertical"></el-divider><span style="color:#9F9F9F;fontSize:14px;">{{item.location}}</span></div>
                <div style="color:#FC6470;fontSize:17px;margin:6px;font-weight:bold;">{{item.tempAverageAmount?Math.ceil(item.tempAverageAmount)+'元/㎡':'待定'}}</div>
            </div>
        </div>
        <div style="textAlign:center;margin-top:10px;" v-if="housestatus==''"><el-button type="primary" size="mini" @click="loadMoreHouseList">加载更多</el-button></div>
    </div>
    <!-- //主办单位 -->
    <div style="marginTop:20px;padding:10px;">
        <div class="titbox">
            <div class="engtit">MEDIA</div>
            <div class="tit">媒体支持</div>
        </div>
        <div style="margin-top:20px;margin-bottom: 20px;">
            <div style="display: flex;align-items: center;justify-content: space-between;">
                <img src="../assets/images/06.png" style="width: 32%;">
                <img src="../assets/images/07.png" style="width: 32%;"/>
                <img src="../assets/images/08.png" style="width: 32%;"/>
            </div>
            <div style="display: flex;align-items: center;justify-content:center;margin-top: 20px;">
                <img src="../assets/images/09.png" style="margin-right: 16px;height:118px;">
                <img src="../assets/images/10.png" style="height:118px;">
            </div>
        </div>

    </div>
    <div style="height:0.375rem;background:#fff;"></div>
    <div style="width:100%;margin:0 auto;display:flex;flex-direction:row;justify-content:center;">
        <div style="padding:1.25rem 0.5rem;">
            <div style="textAlign:left;color:#5a5a5a;font-size:14px;color:#fff;"><span>公安备案号53010202001422 滇ICP备2022001240号</span></div>
        </div>
    </div>
  </div>
</template>

<script>
import {initHome} from '@/api/survey'
import {imgsrc} from '@/api/imageprefix'
import VideoPlay from '@/components/videoplayer'
export default {
    name:'mobile',
    components:{
        VideoPlay
    },
    data(){
        return {
            housestatus:'',
            imgsrc:'',
            homeparam:{
                cityId:533100,
                pageSize:8,
                pageNum:0
            },
            houseList:[],//好房子
            moreparam:{
                fVideoTypeId:9603,
                pageSize:4,
                pageNum:0
            }
        }
    },
    created(){
        let id=this.$route.query.id
        if(typeof(id)!=='undefined' && id!='' && id!=null){
            this.homeparam.cityId=id
        }else{
            this.homeparam.cityId=533100
        }
        this.imgsrc=imgsrc
        this.initCountyandHouseList()
    },
    mounted(){
       
    },
    methods:{
        loadMoreHouseList(){
            this.homeparam.pageNum+=1
            this.initCountyandHouseList()
        },
        goHouseDetail(item){
            window.open(`https://ynydc.com/resources/webapp/index.html#/pages/details/housedetail?houseId=${item.id}&userid=0`,"_blank")
        },
        initCountyandHouseList(){
            initHome(this.homeparam).then((result) => {
                if(result.code==200){
                    this.houseList=[...this.houseList,...result.data.fatherPreMesses]
                    if((this.homeparam.pageNum+1)*8>this.houseList.length){
                        this.housestatus='nomore'
                    }
                }else{
                    this.$message({type:'error',message:'暂无数据'})
                    this.houseList=[]
                }
            }).catch((err) => {
                console.log(err)
            });
        }
    }
}
</script>

<style scoped lang="less">
    .tit{
      text-align:center;
      font-size: 18px;
      font-family: Microsoft YaHei;
      color: #fff;
      position: absolute;
      left: 50%;
      top:14px;
      transform: translateX(-50%);
    }
    .titbox{
        text-align: center;
        position: relative;
        height: 68px;
        line-height: 68px;
    }
    .engtit{
        font-size: 44px;
        background: linear-gradient(to bottom,#c51e1d, #c51e1d);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        font-weight: bold;
    }
    /deep/ .el-button--primary{
        background: #e8d09f;
        border-color:#e8d09f;
        color:#6b1114;
    }
</style>
